import { touchTarget } from "./tokens";

/**
 * `sx` mixin for web station page controls: 48 px hit area, large bold numerals. Plain objects so
 * they can be spread: `sx={{ ...stationControl, px: 4 }}`.
 */
export const stationControl = {
  minWidth: touchTarget,
  minHeight: touchTarget,
  fontSize: 18,
  fontWeight: 800,
};

/** `sx` mixin for web station tiles (student or event pickers). */
export const stationTile = {
  minHeight: 64,
};
